<script setup lang="ts">
defineProps<{
  /** Either a number in seconds or a string in the format `mm:ss` */
  duration: number | `${number}:${number}`
}>()
</script>
<template>
  <div
    class="absolute right-2 bottom-2 flex items-center rounded-sm bg-black/30 px-1.5 py-0.5 text-sm text-white backdrop-blur-sm"
  >
    <SvgoVideoPlay class="size-2.5 fill-current stroke-current" /><time
      class="ml-2"
      >{{ typeof duration == "string" ? duration : formatTime(duration) }}</time
    >
  </div>
</template>
